const WHATSAPP_URL = "https://wa.me/5547992561262?text=Olá!%20Gostaria%20de%20solicitar%20um%20orçamento.";

export default function HeroSection() {
  const scrollToContact = () => {
    const el = document.getElementById("contato");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/f94c1989-fcbf-47d1-a7b5-4805e349c998/e5e1019f-228f-4904-9748-eb9086426b96_construlife-casa4.png?v=224845090957e3f4a19548e40e841e68"
          alt="Construlife - Engenharia e Arquitetura"
          className="w-full h-full object-cover object-bottom"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 flex flex-col items-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/15 border border-white/25 text-white text-xs font-medium px-5 py-2 rounded-full mb-8 backdrop-blur-sm">
          <i className="ri-building-4-line text-[#C9A24A]" />
          Engenharia & Arquitetura de Excelência
        </div>

        {/* H1 */}
        <h1 className="text-white font-bold text-5xl md:text-6xl lg:text-7xl leading-tight max-w-4xl mb-6" style={{ fontFamily: "'Poppins', sans-serif" }}>
          Construindo o futuro<br />
          <span style={{ color: "#C9A24A" }}>com engenharia</span> e inovação.
        </h1>

        {/* Subtitle */}
        <p className="text-white/90 text-lg md:text-xl max-w-2xl mb-10 leading-relaxed">
          Projetos completos para construir, regularizar e valorizar seu imóvel com técnica, segurança e qualidade.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 border-2 border-white text-white hover:bg-white hover:text-[#1F1F1F] font-semibold px-8 py-4 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-[15px]"
          >
            <i className="ri-whatsapp-line" />
            Solicitar Orçamento
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/60 animate-bounce">
        <i className="ri-arrow-down-line text-xl" />
      </div>

      {/* Stats bar */}
      <div className="absolute bottom-0 left-0 w-full bg-[#C9A24A]/95 backdrop-blur-sm py-4">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { icon: "ri-building-2-line", value: "150+", label: "Projetos Realizados" },
            { icon: "ri-hammer-line", value: "80+", label: "Obras Executadas" },
            { icon: "ri-user-star-line", value: "120+", label: "Clientes Satisfeitos" },
            { icon: "ri-calendar-check-line", value: "10+", label: "Anos de Mercado" },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className={`${item.icon} text-[#121212] text-2xl`} />
              </div>
              <div>
                <p className="text-[#121212] font-bold text-lg leading-none">{item.value}</p>
                <p className="text-[#1F1F1F]/80 text-xs">{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
